import React from 'react';
import SeoHead from '@/components/layout/SeoHead';
import Hero from '@/components/sections/Hero';
import TrustSignals from '@/components/sections/TrustSignals';
import RealCost from '@/components/sections/RealCost';
import ServicesGrid from '@/components/sections/ServicesGrid';
import HowItWorks from '@/components/sections/HowItWorks';
import Pricing from '@/components/sections/Pricing';
import FAQ from '@/components/sections/FAQ';
import WhoWeHelp from '@/components/sections/WhoWeHelp';
import BrandShowcase from '@/components/sections/BrandShowcase';
import ServiceAreas from '@/components/sections/ServiceAreas';
import Portfolio from '@/components/sections/Portfolio';
import QuoteSection from '@/components/sections/QuoteSection';
import CannotTake from '@/components/sections/CannotTake';
import { buildOrganizationJsonLd } from '@/lib/entitySchema';

export default function Home() {
  return (
    <>
      <SeoHead
        title="Ohana Property & Transition Services | Estate Cleanouts & Property Transitions in Columbus, IN"
        description="Columbus, Indiana estate cleanouts and property transitions. Woman-owned, MBE & WBE certified. Senior downsizing, inherited property clearing, and pre-listing prep across Bartholomew County and Central Indiana. Call (812) 302-6833."
        canonical="https://ohanapropertyexperts.com/"
        jsonLd={buildOrganizationJsonLd()}
      />
      <Hero />
      <TrustSignals />
      <RealCost />
      <ServicesGrid />
      <HowItWorks />
      <Pricing />
      <FAQ />
      <CannotTake />
      <WhoWeHelp />
      <BrandShowcase />
      <ServiceAreas />
      <Portfolio />
      <QuoteSection />
    </>
  );
}
